import { useLayoutEffect, useRef } from 'react';
import useWorkspaceMassActionsStore from '../../../../../stores/WorkspaceMassActions/workspaceMassActions.store';
import { WorkspaceMassActionsConfig } from '../../MassActionsBar/massActionsBar.types';

export function useWorkspaceMassActions<T>(config: WorkspaceMassActionsConfig<T>) {
  const setConfig = useWorkspaceMassActionsStore((state) => state.setConfig);
  const publishedConfigRef = useRef<WorkspaceMassActionsConfig<unknown> | null>(null);

  useLayoutEffect(() => {
    const nextConfig = config as WorkspaceMassActionsConfig<unknown>;
    if (nextConfig === publishedConfigRef.current) {
      return;
    }
    publishedConfigRef.current = nextConfig;
    setConfig(nextConfig);
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: unmount-only cleanup, must run once
  useLayoutEffect(
    () => () => {
      if (useWorkspaceMassActionsStore.getState().config === publishedConfigRef.current) {
        setConfig(null);
      }
    },
    [],
  );
}
